import { c as _c } from "react/compiler-runtime";
import * as motion from 'motion/react-client';
import { useLocalization } from '@/app/(app)/_providers/localization/LocalizationProvider';
import { cn } from '@/utilities/ui';
export type ModeValue = 'consultant' | 'problem-solver' | 'compare';
export function ModeTabs(t0) {
  const $ = _c(14);
  const {
    value,
    onChange
  } = t0;
  const {
    messages
  } = useLocalization();
  let t1;
  if ($[0] !== messages.chat.modeTabs.consultant) {
    t1 = {
      value: "consultant",
      label: messages.chat.modeTabs.consultant
    };
    $[0] = messages.chat.modeTabs.consultant;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== messages.chat.modeTabs.problemSolver) {
    t2 = {
      value: "problem-solver",
      label: messages.chat.modeTabs.problemSolver
    };
    $[2] = messages.chat.modeTabs.problemSolver;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== messages.chat.modeTabs.compare) {
    t3 = {
      value: "compare",
      label: messages.chat.modeTabs.compare
    };
    $[4] = messages.chat.modeTabs.compare;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = [t1, t2, t3];
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const modeOptions = t4;
  let t5;
  if ($[10] !== modeOptions || $[11] !== onChange || $[12] !== value) {
    t5 = <div className="border-border bg-muted inline-flex rounded-full border p-0.75" role="tablist" aria-label="Assistant mode">{modeOptions.map(option => {
        const isActive = value === option.value;
        return <motion.button key={option.value} type="button" role="tab" aria-selected={isActive} onClick={() => onChange(option.value)} className={cn("relative inline-flex items-center justify-center rounded-full px-3.5 py-1.5 text-[13px] font-medium transition-colors", isActive ? "text-foreground" : "text-muted-foreground hover:text-foreground")} whileTap={{
          scale: 0.98
        }}>{isActive && <motion.span layoutId="mode-tab-indicator" className="bg-background absolute inset-0 rounded-full shadow-sm" transition={{
            type: "spring",
            bounce: 0.2,
            duration: 0.4
          }} />}<span className="relative z-10">{option.label}</span></motion.button>;
      })}</div>;
    $[10] = modeOptions;
    $[11] = onChange;
    $[12] = value;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}